import React from 'react';
import { useRecoilState } from 'recoil';
import selectedCheckboxsAtom from '../../recoils/useSelectedCheckboxsReverseSearch/selectedCheckboxsAtom';
import { BoxCellCustom } from './BoxCellCustom';

export const PackageTypeCellRenderer: React.FC = (props: any) => {
  const { data } = props;
  const [listCheckbox] = useRecoilState(selectedCheckboxsAtom);

  //Handling render box cell in first row for reverse table
  if (data.typeColumn && data.typeColumn === 'first-row') {
    return <BoxCellCustom props={props} />;
  }

  //Handling render box cell in seconds row for reverse table
  if (data.typeColumn && data.typeColumn === 'second-row') {
    const removeDuplicateFromList = data.productVariations.filter((obj1:any)=>{
      return data.productVariations.findIndex((obj2:any)=>{return obj2?.packageType?.name === obj1?.packageType?.name}) === data.productVariations.indexOf(obj1)
    })
    return (
      <>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            lineHeight: '1.8'
          }}
        >
          {removeDuplicateFromList &&
            removeDuplicateFromList.map((item: any) => {
              return (
                <span
                  key={item?.packageType?.name}
                  className={
                    !listCheckbox.includes(props.colDef.field)
                      ? 'hide-value'
                      : 'text-primary'
                  }
                >
                  {item?.packageType?.name}
                </span>
              );
            })}
        </div>
      </>
    );
  }

  return (
    <>
      <div
        style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.8', paddingTop: '10px', paddingBottom: '10px' }}
      >
        {data.productVariations &&
          data.productVariations.map((item: any, index: number) => {
            return <span key={index}>{item?.packageType?.name}</span>;
          })}
      </div>
    </>
  );
};
